module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('h2', {
    staticClass: "tocf1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Preface"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Preface")])])]), _vm._v(" "), _c('h2', {
    staticClass: "tocf1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Ack"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Acknowledgements")])])]), _vm._v(" "), _c('h2', {
    staticClass: "tocf1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Notes"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('h2', {
    staticClass: "tocf"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Map"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Map")])])]), _vm._v(" "), _c('h2', {
    staticClass: "tocaa"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01"
    }
  }, [_c('span', {
    staticClass: "space1aa"
  }, [_vm._v("Chapter 1:")]), _vm._v(" Malaya, Singapore and the Dutch East Indies 1941–42")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocaa"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter02"
    }
  }, [_c('span', {
    staticClass: "space1aa"
  }, [_vm._v("Chapter 2:")]), _vm._v(" Rabaul 1942")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocaa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space1aa"
  }, [_vm._v("Chapter 3:")]), _vm._v(" Darwin, the Arafura Sea and Timor 1942–43")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocaa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space1aa"
  }, [_vm._v("Chapter 4:")]), _vm._v(" Kokoda – the Japanese advance 1942")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocaa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space1aa"
  }, [_vm._v("Chapter 5:")]), _vm._v(" Milne Bay 1942")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocaa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space1aa"
  }, [_vm._v("Chapter 6:")]), _vm._v(" Kokoda – the Japanese retreat 1942")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocaa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space1aa"
  }, [_vm._v("Chapter 7:")]), _vm._v(" The Battle of Buna 1942–43")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocaa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space1aa"
  }, [_vm._v("Chapter 8:")]), _vm._v(" Escape from Buna 1943")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocaa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space1aa"
  }, [_vm._v("Chapter 9:")]), _vm._v(" Air Combat – New Guinea and the Solomon Islands 1942–43")])]), _vm._v(" "), _c('h2', {
    staticClass: "toctaa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spacea1"
  }, [_vm._v("Chapter 10:")]), _vm._v(" Wau and Salamaua 1943")])]), _vm._v(" "), _c('h2', {
    staticClass: "toctaa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spacea1"
  }, [_vm._v("Chapter 11:")]), _vm._v(" Lae 1943")])]), _vm._v(" "), _c('h2', {
    staticClass: "toctaa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spacea1"
  }, [_vm._v("Chapter 12:")]), _vm._v(" Finschhafen 1943")])]), _vm._v(" "), _c('h2', {
    staticClass: "toctaa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spacea1"
  }, [_vm._v("Chapter 13:")]), _vm._v(" Shaggy Ridge 1943–44")])]), _vm._v(" "), _c('h2', {
    staticClass: "toctaa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spacea1"
  }, [_vm._v("Chapter 14:")]), _vm._v(" The Cowra Prisoner of War Breakout 1944")])]), _vm._v(" "), _c('h2', {
    staticClass: "toctaa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spacea1"
  }, [_vm._v("Chapter 15:")]), _vm._v(" The Battle of Leyte Gulf 1944")])]), _vm._v(" "), _c('h2', {
    staticClass: "toctaa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spacea1"
  }, [_vm._v("Chapter 16:")]), _vm._v(" Wewak 1944–45")])]), _vm._v(" "), _c('h2', {
    staticClass: "toctaa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spacea1"
  }, [_vm._v("Chapter 17:")]), _vm._v(" New Britain 1944–45")])]), _vm._v(" "), _c('h2', {
    staticClass: "toctaa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spacea1"
  }, [_vm._v("Chapter 18:")]), _vm._v(" Bougainville 1944–45")])]), _vm._v(" "), _c('h2', {
    staticClass: "toctaa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spacea1"
  }, [_vm._v("Chapter 19:")]), _vm._v(" Tarakan 1945")])]), _vm._v(" "), _c('h2', {
    staticClass: "toctaa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spacea1"
  }, [_vm._v("Chapter 20:")]), _vm._v(" Philippines, Borneo and the Dutch East Indies 1944–45")])]), _vm._v(" "), _c('h2', {
    staticClass: "toctaa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spacea1"
  }, [_vm._v("Chapter 21:")]), _vm._v(" The End of the War 1945")])]), _vm._v(" "), _c('h2', {
    staticClass: "toctaa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spacea1"
  }, [_vm._v("Chapter 22:")]), _vm._v(" The Surrender in New Guinea")])]), _vm._v(" "), _c('h2', {
    staticClass: "toctaa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spacea1"
  }, [_vm._v("Chapter 23:")]), _vm._v(" Prisoners of the Australians")])]), _vm._v(" "), _c('h2', {
    staticClass: "toctaa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/32_Chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spacea1"
  }, [_vm._v("Chapter 24:")]), _vm._v(" After the War")])]), _vm._v(" "), _c('h2', {
    staticClass: "toctaa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/33_Chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spacea1"
  }, [_vm._v("Chapter 25:")]), _vm._v(" Reflections")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocf2aa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/34_Appendix_A",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "spacea2"
  }, [_vm._v("Appendix A:")]), _vm._v(" Life in the Imperial Japanese Navy")])])]), _vm._v(" "), _c('h2', {
    staticClass: "tocf2aa_"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Appendix_B",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "spacea2"
  }, [_vm._v("Appendix B:")]), _vm._v(" Aircraft and Air Tactics")])])]), _vm._v(" "), _c('h2', {
    staticClass: "tocf2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/36_Endnote",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Endnotes")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-132b06ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 69
// module chunks = 0